export default __webpack_public_path__ + "images/e731fcf41909d693225dba89fef933a4.png";